"use strict";
exports.__esModule = true;
var react_1 = require("react");
var filterChildren = function (children, subComponent) {
    return react_1.Children.toArray(children).filter(function (child) {
        var childWithType = child;
        return ((childWithType &&
            childWithType.type &&
            (childWithType.type.displayName || childWithType.type.name)) ===
            (subComponent.displayName || subComponent.name));
    });
};
exports["default"] = filterChildren;
